import * as T from '../utilities/frontendTypes';
import { DdRun } from "@eip/shared/types/dueDiligence.types";
import { apiGet, apiGetBlob, apiPut } from './apiClient';

export async function getInProgressAssessmentAsync(userId: T.UserId): Promise<{success: boolean, founder: T.User}> {
  return apiGet<{success: boolean, founder: T.User}>(`/api/experts/get-in-progress-assessment/${userId}`);
}

export async function getSubmittedFounderHeaders(): Promise<T.ExpertFounderHeadersResponse> {
  return apiGet<T.ExpertFounderHeadersResponse>("/api/experts/get-submitted-founders");
}

export async function submitFounderAssessment(id: T.UserId, assessment: T.ScoreBreakdown, duration: number): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/submit-assessment", { id, assessment, duration });
}

export async function saveFounderAssessment(id: T.UserId, duration: number, tierRec?: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/save-assessment", { id, tierRec, duration });
}

export async function saveFounderFullAssessment(id: T.UserId, assessment: T.ScoreBreakdown, duration: number): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/save-assessment", { id, assessment, duration });
}

export async function getExpertAssesmentStats(): Promise<{success: boolean, foundersArray: T.ExpertMemberHeader[], name: string, link: string}> {
  return apiGet<{success: boolean, foundersArray: T.ExpertMemberHeader[], name: string, link: string}>("/api/experts/get-stats");
}

export async function addDDFlag(id: T.UserId, notes: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/add-dd-flag", { id, notes });
}

export async function getMemberDetails(id: T.UserId): Promise<T.MemberDetailsResponse> {
  return apiGet<T.MemberDetailsResponse>(`/api/experts/memberships/list/${id}`);
}

/** Read-only latest terminal DD screening for an application the expert is assessing. */
export async function getLatestDdRun(applicationId: T.ApplicationId): Promise<{ success: boolean; run: DdRun | null }> {
  return apiGet<{ success: boolean; run: DdRun | null }>(`/api/experts/applications/${applicationId}/due-diligence/latest`);
}

export async function getRegionAdminNotes(appId: T.ApplicationId): Promise<{success: boolean, notes: T.NotesObject[]}> {
  return apiGet<{success: boolean, notes: T.NotesObject[]}>(`/api/experts/get-admin-notes/${appId}`);
}

export async function addNewNote(id: T.ApplicationId, notes: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/add-new-note", { id, notes });
}

export async function getDownloadUrl(docKey: string): Promise<{success: boolean, url: string }> {
  return apiGet<{success: boolean, url: string}>(`/api/experts/get-pdf/${docKey}`);
}

export async function getPdfBytes(docKey: string): Promise<ArrayBuffer> {
  return apiGetBlob(`/api/experts/get-pdf-bytes/${docKey}`);
}

export async function updateCalendlyLink(newLink: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/update-calendly-link", { newLink });
}

export async function addConflict(id: T.ApplicationId, notes: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/add-conflict", { id, notes });
}

export async function sendIpeInvite(id: T.ApplicationId): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/send-invite", { id });
}

export async function setBoardReview(id: T.ApplicationId): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/board-review", { id });
}

export async function removeBoardReview(id: T.ApplicationId): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/remove-board-review", { id });
}

export async function addIpeMeeting(id: T.ApplicationId, meetingType: string, duration: number, date: Date, notes: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/add-ipe-meeting", { id, meetingType, duration, date, notes });
}

export async function saveIpeAssessment(id: T.ApplicationId, ipAssessmentObj: T.IpAssessmentObj, complete: boolean): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/save-ip-assessment", { id, ipAssessmentObj, complete });
}

export async function saveIpeRejection(id: T.ApplicationId, ipRejectionObj: T.IpRejectionObj, complete: boolean): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/save-ip-rejection", { id, ipRejectionObj, complete });
}

export async function sendSowFeedback(sowFeedback: string, sowId: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/add-sow-feedback", { sowFeedback, sowId });
}

export async function expertApproveSow(sowId: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/experts/approve-sow", { sowId });
}
